import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '../../context/AuthContext';
import { AppConfigProvider } from '../../context/AppConfigContext';
import { AlertProvider } from '../../context/AlertContext';
import { ModalProvider } from '../../context/ModalContext';
import { CompanyProvider } from '../../context/CompanyContext';
import { ThemeProvider } from '../../context/ThemeContext';
import { DrawerProvider } from '../../context/DrawerContext';
import ErrorBoundary from '../ui/feedback/ErrorBoundary';
import { ISLRProvider } from '../../context/ISLRContext';
import { IVAProvider } from '../../context/IVAContext';

export const GlobalProviders = ({ children }) => {
    return (
        <ErrorBoundary>
            <Router>
                <AuthProvider>
                    <AppConfigProvider>
                        <AlertProvider>
                            <ModalProvider>
                                <CompanyProvider>
                                    <ThemeProvider>
                                        <DrawerProvider>
                                            <IVAProvider>
                                                <ISLRProvider>
                                                    {children}
                                                </ISLRProvider>
                                            </IVAProvider>
                                        </DrawerProvider>
                                    </ThemeProvider>
                                </CompanyProvider>
                            </ModalProvider>
                        </AlertProvider>
                    </AppConfigProvider>
                </AuthProvider>
            </Router>
        </ErrorBoundary>
    );
};
